import { ifAuthenticated } from "@/Modules/Auth/Auth/Routes/guards"
import { ifFractional } from "./guards"

export default [
  {
    path: "/welcome",
    name: "Fractional Welcome",
    meta: { title: "Dobrodošli" },
    component: () => import(/* webpackChunkName: "Fractional Welcome" */ "@/Modules/Fractional/Views/Welcome/Welcome"),
    beforeEnter: ifAuthenticated
  },
  {
    path: "/profile",
    name: "Fractional Profile",
    meta: { title: "Moj profil" },
    component: () => import(/* webpackChunkName: "Fractional Profile" */ "@/Modules/Fractional/Views/Profile/Profile"),
    beforeEnter: ifFractional
  },
  {
    path: "/experience",
    name: "Fractional Experience",
    meta: { title: "Delovne izkušnje" },
    component: () => import(/* webpackChunkName: "Fractional Experience" */ "@/Modules/Fractional/Views/Experience/Experience"),
    beforeEnter: ifFractional
  },
  {
    path: "/documents",
    name: "Fractional Documents",
    meta: { title: "Dokumenti" },
    component: () => import(/* webpackChunkName: "Fractional Documents" */ "@/Modules/Fractional/Views/Documents/Documents"),
    beforeEnter: ifFractional
  }
]
